import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import AccountStatusCardContainer from "./AccountStatusCardContainer";
import AccountCostLimitsCard from "./AccountCostLimitsCard";
import AccountSettingsCard from "./AccountSettingsCard";

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: 16,
    marginTop: 24
  },
  action: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row-reverse",
    paddingRight: 8
  }
});

class AccountSettings extends React.Component {
  componentWillMount() {
    this.props.fetchCostLimits();
    this.props.fetchAccountSettings();
  }

  componentWillUnmount() {
    this.props.clearAccountSettings();
  }

  render() {
    const { classes, account } = this.props;
    return (
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <AccountStatusCardContainer account={account} />
          </Grid>
          <Grid item xs={12}>
            <AccountSettingsCard {...this.props} />
          </Grid>
          <Grid item xs={12}>
            <AccountCostLimitsCard {...this.props} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

AccountSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  fetchCostLimits: PropTypes.func.isRequired,
  costLimits: PropTypes.object.isRequired
};

export { AccountSettings };

export default withStyles(styles, { name: "AccountSettings" })(AccountSettings);



// WEBPACK FOOTER //
// ./src/AccountSettings.js